<template>
	<div class="navbar">
		<div class="navbar-left">
			<!-- 移动端菜单按钮 -->
			<div v-if="isMobile" class="mobile-menu-btn" @click="toggleMobileSidebar">
				<i class="el-icon-s-fold"></i>
			</div>
			<div class="logo">
				<img :src="$img($getter('setting').value9)" alt="logo">
			</div>
		</div>

		<!-- 中心区域 -->
		<div class="navbar-center-container" :class="{ 'mobile-hidden': isMobile }">
			<div class="breadcrumb" v-if="showBreadcrumb">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index">
						{{ item }}
					</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
		</div>

		<div class="navbar-right">
			<div class="operation">
				<!-- 刷新按钮 -->
				<el-tooltip content="刷新页面" placement="bottom" :disabled="isMobile">
					<div class="nav-item refresh-btn" @click="refresh" :class="{ 'mobile-hidden': isMobile }">
						<i class="el-icon-refresh-right"></i>
					</div>
				</el-tooltip>

				<!-- 全屏切换 -->
				<el-tooltip :content="isFullscreen ? '退出全屏' : '全屏显示'" placement="bottom" :disabled="isMobile">
					<div class="nav-item fullscreen-btn" @click="toggleFullscreen" :class="{ 'mobile-hidden': isMobile }">
						<i class="el-icon-full-screen"></i>
					</div>
				</el-tooltip>

				<!-- 用户信息 -->
				<el-dropdown class="user-dropdown" @command="handleUserCommand" trigger="click">
					<div class="nav-item user-info">
						<div class="user-details">
							<span class="user-name" :class="{ 'mobile-hidden': isMobile }">你好，{{ info.name || '管理员' }}</span>
							<i class="el-icon-arrow-down"></i>
						</div>
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="settings">
							<i class="el-icon-setting"></i>
							账号设置
						</el-dropdown-item>
						<el-dropdown-item divided command="logout">
							<i class="el-icon-unlock"></i>
							退出登录
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'navbar',
		data() {
			return {
				info: {},
				isFullscreen: false,
				unreadCount: 0,
				showBreadcrumb: true,
				breadcrumbList: [],
				isMobile: false,
				windowWidth: 0
			};
		},
		mounted() {
			this.getInfo();
			this.getMenu();
			this.initFullscreenListener();
			this.updateBreadcrumb();
			this.checkDeviceType();
			window.addEventListener('resize', this.handleResize);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize);
		},
		watch: {
			'$route': 'updateBreadcrumb'
		},
		methods: {
			getInfo(){
				this.$get('sys-admin/'+this.$getter('AdminInfo').id).then(res=>{
					this.info = res.data;
					this.$vuex('AdminInfo', res.data, true);
				}).catch(err=>{
					 this.$warning(err);
				})
			},
			getMenu(){
				this.$get('sys-admin-menu').then(res=>{
					this.$load(false);
					try {
						this.$vuex('menu', res.data, true);
					}catch(err){
						this.$warning('登录失败');
					}
				}).catch(err=>{
					this.$load(false);
					this.$warning(err);
				})
			},
			refresh(){
				// 添加刷新动画
				const refreshBtn = document.querySelector('.refresh-btn');
				if (refreshBtn) {
					refreshBtn.classList.add('refreshing');
				}
				setTimeout(() => {
					this.$router.go(0);
				}, 500);
			},
			logout() {
				this.$confirm('确定要退出登录吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					customClass: 'logout-confirm'
				}).then(() => {
					this.$vuex('AdminInfo',{},true);
					this.$vuex('UserCheck',{},true);
					this.$router.replace("/");
					this.$success('退出成功!');
				}).catch(() => {});
			},
			toggleFullscreen() {
				if (!document.fullscreenElement) {
					document.documentElement.requestFullscreen().then(() => {
						this.isFullscreen = true;
					}).catch(() => {
						// 全屏请求失败
						this.isFullscreen = false;
					});
				} else {
					document.exitFullscreen().then(() => {
						this.isFullscreen = false;
					});
				}
			},
			initFullscreenListener() {
				document.addEventListener('fullscreenchange', () => {
					this.isFullscreen = !!document.fullscreenElement;
				});
			},
			handleUserCommand(command) {
				switch (command) {
					case 'profile':
						this.$navto('/setup/personal/setting');
						break;
					case 'settings':
						this.$navto('/setup/personal/setting');
						break;
					case 'logout':
						this.logout();
						break;
				}
			},
			updateBreadcrumb() {
				// 根据路由更新面包屑
				const matched = this.$route.matched;
				this.breadcrumbList = matched.map(route => {
					const meta = route.meta || {};
					return meta.title || route.name || '';
				}).filter(item => item && item.trim() !== '');
			},
			toggleMobileSidebar() {
				// 触发父组件的事件
				this.$emit('toggle-mobile-sidebar');
			},
			handleResize() {
				this.windowWidth = window.innerWidth;
				this.checkDeviceType();
			},
			checkDeviceType() {
				this.isMobile = window.innerWidth <= 768;
			}
		}
	};
</script>

<style lang="scss" scoped>
	.navbar {
		height: 64px;
		min-height: 64px;
		background-color: #fff;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 24px;
		border-bottom: 2px solid #f5f5f5;
		position: relative;
		z-index: 1000;

		.navbar-left {
			display: flex;
			align-items: center;
			flex-shrink: 0;
			gap: 12px;
			
			.mobile-menu-btn {
				display: none;
				align-items: center;
				justify-content: center;
				width: 32px;
				height: 32px;
				border-radius: 6px;
				cursor: pointer;
				transition: all 0.3s ease;
				color: #555555;
				
				&:hover {
					background: rgba(0, 0, 0, 0.05);
					color: #000000;
				}
				
				i {
					font-size: 20px;
				}

				// 移动端显示
				@media (max-width: 768px) {
					display: flex;
				}
			}
			
			.logo {
				display: flex;
				align-items: center;
				color: #555555;
				
				img {
					max-height: 40px;
					max-width: 120px;
					object-fit: contain;
				}
			}
		}

		/* 修改为中心容器，使用绝对定位但保持垂直居中 */
		.navbar-center-container {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			z-index: 1;
			color: #555555;
			
			.breadcrumb {
				:deep(.el-breadcrumb) {
					font-size: 18px;
					display: flex;
					align-items: center;
					height: 100%;
					
					/* 隐藏第一个面包屑项前的分隔符 */
					.el-breadcrumb__item {
						display: flex;
						align-items: center;
						
						/* 隐藏第一个面包屑项前的分隔符 */
						&:first-child .el-breadcrumb__separator {
							display: none !important;
						}
						
						.el-breadcrumb__inner {
							color: #555555;
							transition: color 0.3s ease;
							
							&:hover {
								color: #000000;
							}
						}
						
						&:last-child {
							.el-breadcrumb__inner {
								font-weight: 500;
								color: #555555;
							}
							
							/* 隐藏最后一个面包屑项后的分隔符 */
							.el-breadcrumb__separator {
								display: none !important;
							}
						}
					}
					
					.el-breadcrumb__separator {
						color: #666666;
						display: flex;
						align-items: center;
						margin: 0 8px;
					}
				}
			}
			
			// 移动端隐藏
			&.mobile-hidden {
				@media (max-width: 768px) {
					display: none;
				}
			}
		}

		.navbar-right {
			display: flex;
			align-items: center;
			flex-shrink: 0;
			
			.operation {
				display: flex;
				align-items: center;
				gap: 12px;

				.nav-item {
					display: flex;
					align-items: center;
					padding: 10px 14px;
					border-radius: 8px;
					cursor: pointer;
					transition: all 0.3s ease;
					color: #555555;
					position: relative;
					
					&:hover {
						background: rgba(0, 0, 0, 0.05);
						color: #000000;
						transform: translateY(-1px);
					}
					
					i {
						font-size: 22px;
					}
					
					// 移动端隐藏
					&.mobile-hidden {
						@media (max-width: 768px) {
							display: none;
						}
					}
				}

				.refresh-btn {
					&.refreshing {
						i {
							animation: rotating 1s linear infinite;
						}
					}
				}

				.user-dropdown {
					.user-info {
						display: flex;
						align-items: center;
						gap: 10px;
						padding: 6px 14px 6px 10px;
						
						.user-details {
							display: flex;
							align-items: center;
							gap: 6px;
							
							.user-name {
								font-size: 16px;
								font-weight: 500;
								white-space: nowrap;
								color: #555555;
								
								// 移动端隐藏用户名
								&.mobile-hidden {
									@media (max-width: 768px) {
										display: none;
									}
								}
							}
							
							.el-icon-arrow-down {
								font-size: 16px;
								color: #555555;
								transition: transform 0.3s ease;
							}
						}
						
						&:hover {
							.user-details .el-icon-arrow-down {
								transform: rotate(180deg);
								color: #000000;
							}
						}
					}
				}
			}
		}
	}

	// 下拉菜单文字颜色
	:deep(.el-dropdown-menu) {
		.el-dropdown-menu__item {
			color: #555555;
			font-size: 15px;
			
			i {
				color: #555555;
				font-size: 16px;
			}
			
			&:hover {
				color: #000000;
				
				i {
					color: #000000;
				}
			}
		}
	}

	// 旋转动画
	@keyframes rotating {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}

	// 响应式设计
	@media screen and (max-width: 768px) {
		.navbar {
			padding: 0 16px;
			height: 56px;
			
			.navbar-left {
				.logo {
					img {
						max-height: 36px;
						max-width: 100px;
					}
				}
			}
			
			.navbar-center-container {
				position: static;
				transform: none;
				display: flex;
				align-items: center;
				
				.breadcrumb {
					:deep(.el-breadcrumb) {
						font-size: 16px;
					}
				}
			}
			
			.navbar-right {
				.operation {
					gap: 8px;
					
					.nav-item {
						padding: 8px 10px;
						
						i {
							font-size: 20px;
						}
					}
					
					.user-dropdown {
						.user-info {
							padding: 4px 10px 4px 8px;
							
							.user-details {
								.user-name {
									font-size: 14px;
									font-weight: 500;
								}
								
								.el-icon-arrow-down {
									font-size: 14px;
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 480px) {
		.navbar {
			padding: 0 12px;
			
			.navbar-left {
				.logo {
					img {
						max-height: 32px;
						max-width: 90px;
					}
				}
			}
			
			.navbar-center-container {
				.breadcrumb {
					:deep(.el-breadcrumb) {
						font-size: 14px;
					}
				}
			}
			
			.navbar-right {
				.operation {
					gap: 6px;
					
					.nav-item {
						padding: 6px 8px;
						
						i {
							font-size: 18px;
						}
					}
					
					.user-dropdown {
						.user-info {
							padding: 3px 8px 3px 6px;
							
							.user-details {
								.user-name {
									font-size: 13px;
									font-weight: 500;
								}
								
								.el-icon-arrow-down {
									font-size: 12px;
								}
							}
						}
					}
				}
			}
		}
	}

	// 超小屏手机
	@media screen and (max-width: 360px) {
		.navbar {
			padding: 0 8px;
			
			.navbar-left {
				.logo {
					img {
						max-height: 30px;
						max-width: 80px;
					}
				}
			}
			
			.navbar-center-container {
				.breadcrumb {
					:deep(.el-breadcrumb) {
						font-size: 13px;
					}
				}
			}
			
			.navbar-right {
				.operation {
					gap: 4px;
					
					.nav-item {
						padding: 5px 6px;
						
						i {
							font-size: 16px;
						}
					}
				}
			}
		}
	}
</style>